import { Config, Data, renderContext, walkTree } from '@measured/puck';
import { useContext, useMemo } from 'react';

import { useRenderContext } from '../../../../context/render-context';

type CalculationExpression = {
  expressionName: string;
  respondentType: string;
};

const collectCalculationExpressions = (
  data: Data,
  config: Config,
  allRespondentTypes: string[]
): CalculationExpression[] => {
  if (!data || !config || !allRespondentTypes.length) return [];

  const found: CalculationExpression[] = [];

  walkTree(data, config, (slotContent) => {
    slotContent.forEach((node) => {
      if (node.type === 'MeasureBreakdownBlock' && node.props?.selectedExpressionName) {
        const targetRespondents = node.props.allRespondents
          ? allRespondentTypes
          : [node.props.selectedRespondentType].filter(Boolean);

        targetRespondents.forEach((respondentType: string) => {
          found.push({ expressionName: node.props.selectedExpressionName, respondentType });
        });
      }
    });
    return slotContent;
  });

  return found;
};

export const useCalculationExpressionNames = () => {
  const { surveySet } = useRenderContext();
  const { data, config } = useContext(renderContext);

  const allRespondentTypes = useMemo(() => surveySet?.map((s) => s.respondentType) ?? [], [surveySet]);

  return useMemo(
    () => collectCalculationExpressions(data, config, allRespondentTypes),
    [allRespondentTypes, config, data]
  );
};
